module.exports = __webpack_public_path__ + "mainassets/img/arrow-down.86e8eb4b.png";